<template>
  <el-input
    v-model="search_input"
    :placeholder="placeholder"
    :size="big ? '' : 'medium'"
    :disabled="disabled"
    clearable
    :style="`width: ${width}`"
    :class="['search-input', customClass]"
    @input="onInput"
    @clear="clearSearch"
    @keyup.enter.native="searching"
  >
    <i
      v-if="isPrefix"
      slot="suffix"
      :class="['si-icon-search el-input__icon', { big: big }]"
      @click="searching"
    />
  </el-input>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      default: 'Поиск',
    },
    value: {
      type: String,
      default: '',
    },
    big: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isPrefix: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '450px',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search_input: '',
    }
  },
  watch: {
    value(newVal) {
      this.search_input = newVal
    },
  },
  mounted() {
    this.search_input = this.value
  },
  methods: {
    clearSearch() {
      this.search_input = ''
      this.$emit('clear')
    },
    searching() {
      this.$emit('search', this.search_input)
    },
    onInput() {
      this.$emit('input', this.search_input)
    },
  },
}
</script>

<style lang="sass">
.search-input
  input
    height: 54px
  .si-icon-search.el-input__icon:after
    background: url('~@/assets/img/search.svg') no-repeat
    width: 18px
    height: 20px
    background-size: contain
    cursor: pointer
  .si-icon-search.el-input__icon.big:after
    width: 25px
    height: 25px
    margin: 14px 0
</style>
